import {
    DatePicker as DatePickerCore,
    DatePickerProps,
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
    date: {
        background: '#FFF',
        '& input': {
            paddingTop: 10.5,
            paddingBottom: 10.5,
            fontSize: theme.typography.pxToRem(15),
            height: 19,
        },
    },
}));

export default function DatePicker({ className, ...props }: DatePickerProps) {
    const classes = useStyles();

    return (
        <DatePickerCore
            className={clsx(classes.date, className)}
            inputVariant="outlined"
            {...props}
        />
    );
}
